<template>
  <!-- 新日账单明细 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="serchList"
        @reset="reset(initQuery, 'searchBar', {type: 'clickEvent', name: '结算账单明细（团油）重置', id: '1621476408'})"
        @changeTime="(value,model)=>changeTime(
          value,
          'searchBar',
          'orderSettlementTimeStart',
          'orderSettlementTimeEnd')"
        :loading="tableLoading">
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadDailyDetailListApi" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" @countPoint="$track.clickEvent('结算账单明细（团油）导出', '1621476407')"></download-button>
          <el-button size="mini" @click="gotoOldDetail">8月4日前账单明细 >>></el-button>
        </template>
      </mer-search>
    </el-card>
    <!-- summary 汇总信息 -->
    <sum-panel :labelMap="simpleOrNotSumLabel" :sumInfo="sumInfo" :tipsInfo="tipsInfo"></sum-panel>
    <!-- table 表格 -->
    <el-card shadow="never">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="false">
      </mer-table>
    </el-card>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import dailyBillMix from '@/views/finance/mixins/dailyBill';
import { getDailyDetailQueryApi, getDailyDetailSummaryApi, getDailyDetailListApi, downloadDailyDetailListApi, getWhetherSimpleApi, querySettlementMethodList } from '@/api/finance'
import { getGoldenRight, getStationEnergyType } from '@/api/common'
import { getAllStandardList } from '@/api/order'
import { mapState, mapGetters } from 'vuex'
// 埋点数据
let mdObj = {
  pageview: {
    type: 'pageViewEvent',
    name: '结算账单明细（团油）',
    id: '1621476402'
  },
  serch: {
    type: 'clickEvent',
    name: '结算账单明细（团油）查询',
    id: '1621476404'
  },
  orderSettlementTimeEnd: {
    type: 'clickEvent',
    name: '结算账单明细（团油）时间选择',
    id: '1621476405'
  },
  gasId: {
    type: 'clickEvent',
    name: '结算账单明细（团油）油站',
    id: '1621476444'
  },
  orderType: {
    type: 'clickEvent',
    name: '结算账单明细（团油）账单类型',
    id: '1621476406'
  },
  oilNo: {
    type: 'clickEvent',
    name: '结算账单明细（团油）油号',
    id: '1621476443'
  },
  download: {
    type: 'clickEvent',
    name: '结算账单明细（团油）导出',
    id: '1621476407'
  },
  history: {
    type: 'clickEvent',
    name: '结算账单明细（团油）历史账单查询',
    id: '1621476409'
  }
}
  // 查询表单配置
let formConfig = [
  { label: '油站', type: 'select', modelName: 'gasId', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'gasName', selectValue: 'gasId' },
  { label: '订单号', type: 'input', modelName: 'orderCode', placeholder: '', maxlength: 100 },
  { label: '支付时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss',pickerOptions:{}, clearable:false },
  { label: '账单类型', type: 'select', modelName: 'orderType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'label', selectValue: 'value' },
  { label: '油号', type: 'select', modelName: 'oilNo', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'oilNum', selectValue: 'id' },
  { label: '结算周期', type: 'select', modelName: 'businessCycle', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'desc', selectValue: 'code', clearable: true},
]
// 表格参数配置
let tableConfig = [
  { label: '订单号', prop: 'orderCode', width: 190 },
  { label: '油站名称', prop: 'gasName', width: 200 },
  { label: '结算周期', prop: 'businessCycleName', width: 136  },
  { label: '订单支付时间', prop: 'orderSettlementTime', width: 136  },
  { label: '订单结算时间', prop: 'dealTime', width: 150 },
  { label: '加油金额(元)', prop: 'amountGun', width: 136 },
  { label: '让利金额(元)', prop: 'amountRebate', width: 136},
  { label: '应结算金额(元)', prop: 'amount', width: 136 },
  { label: '通道费金额(元)', prop: 'slottingFee', width: 136 },
  { label: '商家承担营销总金额(元)', prop: 'merchantTotalMarketingAmount', width: 156 },
  { label: '商家承担直降金额', prop: 'amountActivityMerchant', width: 136 },
  { label: '商家承担平台优惠券金额', prop: 'amountPlatformCouponMerchant', width: 156 },
  { label: '商家承担商家优惠券金额', prop: 'merchantCouponAmount', width: 156},
  { label: '商户优惠券售卖金额', prop: 'merchantVoucher', width: 156},
  { label: '商家权益卡优惠金额', prop: 'mctProfitMctAmount', width: 156 },
  { label: '商家承担增长计划总金额(元)', prop: 'merchantGrowthPlanAmount', width: 136 },
  { label: '商家承担点金计划总金额(元)', prop: 'merchantJubaoPlanAmount', width: 136 },
  { label: '商家承担锁客宝总金额(元)', prop: 'merchantCustLockAmount', width: 136 },
  { label: '商家承担营销折扣总金额(元)', prop: 'merchantMktDiscountAmount', width: 136 },
  { label: '会员卡金额', prop: 'vipAccountAmount', width: 156 },
  { label: '实际结算金额(元)', prop: 'realSettlementAmount', width: 136 },
  { label: '油号', prop: 'oilNo', width: 136 },
  { label: '枪号', prop: 'gunNo', width: 136 },
  { label: '升数', prop: 'litre', width: 136 },
  { label: '通道费结算周期', prop: 'slottingCycleName',width: 136 },
  { label: '账单类型', prop: 'orderTypeName',width: 136 },
  { label: '账单状态', prop: 'billStatusName',width: 136 },
  { label: '活动让利金额', prop: 'couponTwoActivityRebate',width: 150 },
  { label: '商户承担活动补贴成本', prop: 'merchantCouponTwoActivityAmount',width: 150 }
]

// const isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
// 金盾权限额外展示字段


export default {
  name: 'bill_dailyBillDetail',
  mixins:[ listPage, queryMix, dailyBillMix ],
  data(){
    return{
      downloadDailyDetailListApi,
      isGas: 1,
      tableData: {},
      sumInfo: {},
      tradeTime:'',
      formConfig,
      tableConfig,
      settlementDisplayType: 4, // 1：完整版 2：截流简单版 3:截流不简单版 4:旧版
    }
  },
  created(){
    this.maidian(mdObj.pageview)
    this.queryEnum()
    // 获取商户ID（vuex或者sessionStorage）
    this.initPage()
    this.getGoldenRight()
    this.getWhetherSimple()
  },
  computed: {
    ...mapState('user', ['userInfo']),
    simpleOrNotSumLabel() {
      return this.settlementDisplayType === 1 ? this.sumLabel : this.settlementDisplayType === 4 ? this.sumLabelOld : this.sumLabelSimple
    },
    ...mapGetters(['platformName'])
  },
  methods:{
    async queryEnum() {
      const { code, result } = await querySettlementMethodList()
      if (code !== 200) return
      const item = this.formConfig.find(item => item.modelName === 'businessCycle')
      item && (item.selectOptions = result)
    },
    // 获取完整版还是截流简单版
    async getWhetherSimple () {
      const { code, result } = await getWhetherSimpleApi()
      if (code !== 200) return
      this.settlementDisplayType = result.settlementDisplayType
      if (this.settlementDisplayType === 2 || this.settlementDisplayType === 3) {
        const hideParams = ['merchantGrowthPlanAmount', 'merchantCustLockAmount', 'merchantJubaoPlanAmount', 'merchantMktDiscountAmount', 'amountRebate', 'amountActivityMerchant', 'amountPlatformCouponMerchant', 'merchantCouponAmount', 'mctProfitMctAmount', 'amount']
        hideParams.map(subItem => {
          const i = this.tableConfig.findIndex(item => item.prop === subItem)
          if (i !== -1) {
            this.tableConfig.splice(i, 1)
          }
        })
      } else if (this.settlementDisplayType === 1) {
        const i = this.tableConfig.findIndex(item => item.prop === 'merchantTotalMarketingAmount')
        if (i !== -1) {
          this.tableConfig.splice(i, 1)
        }
      } else {
        const hideParams = ['merchantGrowthPlanAmount', 'merchantCustLockAmount', 'merchantJubaoPlanAmount', 'merchantMktDiscountAmount', 'merchantTotalMarketingAmount']
        hideParams.map(subItem => {
          const i = this.tableConfig.findIndex(item => item.prop === subItem)
          if (i !== -1) {
            this.tableConfig.splice(i, 1)
          }
        })
      }
    },
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    initPage () {
      this.initQuery()
      this.getAllQueryProps()
      this.getAllOil()
      this.refresh()
      // this.initList(getDailyDetailListApi,true,getDailyDetailSummaryApi)
    },  
    // 设置默认查询条件，默认时间间隔2天
    initQuery () {
      this.tradeTime = ''
      this.initTime('tradeTime', 1, 'searchBar', false, 'orderSettlementTimeStart', 'orderSettlementTimeEnd')
      const { tradeTime, pickerOptions } = this
      const initObj = { tradeTime: [tradeTime, pickerOptions] }
      this.setSearchConfig(initObj)
    },
    getAllQueryProps(){
      this.getQueryStatus()
      //获取油站
      this.getAllGasStations()
    },
    // 获取查询条件：交易类型
    async getQueryStatus () {
      try{
        const { code, result = [] } = await getDailyDetailQueryApi()
        if(code !== 200) return
        const initObj = { orderType: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(err){
        console.log(err)
      }
    },
    // 查询表格数据
    serchList () {
      this.search()
      this.maidian(mdObj.serch)
      let list = ['orderCode', 'orderSettlementTimeStart']
      Object.keys(this.searchBar).forEach(item => {
        if(!list.includes(item) && this.searchBar[item]) {
          let other = {}
          if(item === 'orderType') {
            other.tysj_trade_type = this.searchBar[item] === '10' ? '1' : '2'
          }
          if(item === 'orderSettlementTimeEnd') {
            other.tysj_start_time = this.searchBar.orderSettlementTimeStart
            other.tysj_end_time = this.searchBar.orderSettlementTimeEnd
          }
          mdObj[item].other = other
          this.maidian(mdObj[item])
        }
      })
    },
    //导出
    download () {
      this.maidian(mdObj.download)
      this.downloadFile(downloadDailyDetailListApi,'结算日账单明细')
    },
    gotoOldDetail(){
      this.maidian(mdObj.history)
      this.$router.push({path:'/bill/oldBillDetailList'})
    },
    // 查找目标表格索引
    findColumnIndex (key) {
      return this.tableConfig.findIndex(item => item.prop === key)
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination }
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar }
      this.getSumInfo(data)
      // 判断是否是加气的站, 商户调取接口，需要传gasId,否则默认给油站数据，油站调取接口不需要传参
      if (!this.userInfo.company) {
        this.getStationEnergyTypeApi()
      } else {
        this.getStationEnergyTypeApi({ gasId: data.gasId })
      }
      try{
        const { code, result = [], totalRow = 0 } = await getDailyDetailListApi(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 判断当前油站是加气还是加油
    async getStationEnergyTypeApi (params) {
      try {
        const { code, result } = await getStationEnergyType(params)
        if(code !==200) return
        this.isGas = result
        this.tableConfig[this.findColumnIndex('amountGun')].label = result === 2 ? '金额' : '加油金额'
        this.tableConfig[this.findColumnIndex('oilNo')].label = result === 2 ? '气号' : '油号'
        this.tableConfig[this.findColumnIndex('litre')].label = result === 2 ? '数量' : '升数'
        // 加气还是加油文案修改
        const type = result === 2 ? '气' : '油'
        this.sumLabel.totalOilAmount = `加${type}总金额(元)`
        this.sumLabelSimple.totalOilAmount = `加${type}总金额(元)`
        this.tipsInfo.settlementAmount = `加${type}金额（枪价）- 商家让利金额（合同让利）`
        this.tipsInfo.realSettlementAmount = `加${type}金额（枪价）-让利总金额-商家承担活动直降金额-商家承担平台优惠券总金额-商家承担商家优惠券总金额+商家优惠券售卖金额-商家权益卡优惠总金额-通道费金额`
      } catch (error) {
        console.log(error)
      }
    },
    // 列表汇总（统计）信息
    async getSumInfo (data) {
      try{
        const { code, result } = await getDailyDetailSummaryApi(data)
        if(code !== 200) return
        this.sumInfo = result
      }catch(err){
        console.log(err)
      }
    },
    async getGoldenRight () {
      let tableConfigElse = [
        { label: '金盾优惠金额', prop: 'goldenShieldDiscountAmount', width: 136 },
        { label: `${this.platformName}优惠金额`, prop: 'tyDiscountAmount', width: 136 }
      ]
      try {
        const { code, result } = await getGoldenRight()
        if (code !== 200) return
        if (result) {
          const index = this.tableConfig.findIndex(i => i.prop === 'goldenShieldDiscountAmount')
          if (index > -1) return
          // const index = this.tableConfig.findIndex(item => item.prop === '')
          // this.tableConfig.splice(index, 0, ...tableConfigElse)
          this.tableConfig.splice(14, 0, ...tableConfigElse)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getAllOil(){
      try{
        const {code,result} = await getAllStandardList()
        if(code !==200) return
        const initObj = { oilNo: result || [] }
        this.setSearchConfig(initObj)
      }catch(e){
        console.log(e)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
</style>
